var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { API } from './api';
var OrganizationProvider = /** @class */ (function (_super) {
    __extends(OrganizationProvider, _super);
    function OrganizationProvider(api) {
        var _this = _super.call(this) || this;
        _this.api = api;
        return _this;
    }
    /**
     * Create a new organization
     * @param name name of the new organization
     */
    OrganizationProvider.prototype.createOrganization = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        payload = {
                            name: name
                        };
                        return [4 /*yield*/, this.api.post('organization', payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * ger current user's organization
     */
    OrganizationProvider.prototype.getOrganization = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('organization')];
                    case 1:
                        response = _a.sent();
                        if (response.success && response.message) {
                            return [2 /*return*/, response.message];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rename an organizaiton
     * @param orgIdentifier organization identifier
     * @param newName new name for organization
     */
    OrganizationProvider.prototype.renameOrganization = function (orgIdentifier, newName) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        payload = { newName: newName };
                        return [4 /*yield*/, this.api.post("organization/" + orgIdentifier + "/rename", payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all users in an organization
     * @param orgIdentifier organization identifier
     */
    OrganizationProvider.prototype.getOrganizationUsers = function (orgIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("organization/" + orgIdentifier + "/users")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success ? response.message : []];
                    case 2:
                        err_4 = _a.sent();
                        throw err_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * change user's role in organziaiton
     * @param newRole new role for the user
     * @param userIdentifer user identifier
     * @param orgIdentifier organization identifer
     */
    OrganizationProvider.prototype.changeUserRole = function (newRole, userIdentifer, orgIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        payload = { role: newRole };
                        return [4 /*yield*/, this.api.post("organization/" + orgIdentifier + "/user/" + userIdentifer + "/role", payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                    case 2:
                        err_5 = _a.sent();
                        throw err_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * delete a user from organizaiton
     * @param userIdentifier user identifier
     * @param orgIdentifier organizaiton identifier
     */
    OrganizationProvider.prototype.deleteUser = function (userIdentifier, orgIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("organization/" + orgIdentifier + "/user/" + userIdentifier)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                    case 2:
                        err_6 = _a.sent();
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrganizationProvider.prototype.deleteInvitation = function (token, orgIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("organization/" + orgIdentifier + "/invitations/" + token)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                    case 2:
                        err_7 = _a.sent();
                        throw err_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrganizationProvider.prototype.inviteUser = function (invitations, orgIdentifier, isResend) {
        if (isResend === void 0) { isResend = false; }
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        payload = {
                            invites: invitations
                        };
                        return [4 /*yield*/, this.api.post("organization/" + orgIdentifier + "/invitations" + (isResend ? '?resend=true' : ''), payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrganizationProvider.prototype.getInvitedUsers = function (orgIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("organization/" + orgIdentifier + "/invitations")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.success ? response.message : []];
                    case 2:
                        error_2 = _a.sent();
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * get current user's organziaiton
     */
    OrganizationProvider.prototype.getUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var users, resp, response, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        users = void 0;
                        return [4 /*yield*/, this.getOrganization()];
                    case 1:
                        resp = _a.sent();
                        if (!resp) return [3 /*break*/, 3];
                        this.orgIdentifier = resp.organizationIdentifier;
                        return [4 /*yield*/, this.getOrganizationUsers(this.orgIdentifier)];
                    case 2:
                        response = _a.sent();
                        users = response.users;
                        _a.label = 3;
                    case 3: return [2 /*return*/, users ? users : ''];
                    case 4:
                        err_8 = _a.sent();
                        throw err_8;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check if organization has tager users
     */
    OrganizationProvider.prototype.hasTaggerUsers = function (orgIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_9;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        if (!!this.usersList) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.getOrganizationUsers(orgIdentifier)];
                    case 1:
                        _a.usersList = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.usersList.users.some(function (userItem) { return userItem.role === 'User'; })];
                    case 3:
                        err_9 = _b.sent();
                        throw err_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Reset cached data
     */
    OrganizationProvider.prototype.resetInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.usersList = null;
                return [2 /*return*/];
            });
        });
    };
    OrganizationProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API])
    ], OrganizationProvider);
    return OrganizationProvider;
}(BaseProvider));
export { OrganizationProvider };
//# sourceMappingURL=organization.js.map


// WEBPACK FOOTER //
// ./src/providers/organization.ts.pre-build-optimizer.js